export default __webpack_public_path__ + "static/media/featRaceBgMb.7adce1c2.png";